module.exports = __webpack_public_path__ + "img/202408021436306w6A.1df72a38.png";